import React from "react"
import { Link } from "gatsby"
import { AiOutlineCodeSandbox } from "react-icons/ai"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { rhythm, scale } from "../utils/typography"

const SocialIcons = () => {
  return (
    <div className="social-icons-wrapper">
      <a
        href="https://github.com/machy44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={["fab", "github"]} />
      </a>
      <a
        href="https://www.linkedin.com/in/alen-sljivar-a0321910a"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={["fab", "linkedin"]} />
      </a>
      <a
        href="https://twitter.com/AlenMachy44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={["fab", "twitter"]} />
      </a>
      <a
        href="https://codepen.io/machy44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <FontAwesomeIcon icon={["fab", "codepen"]} />
      </a>
      <a
        href="https://codesandbox.io/u/machy44"
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiOutlineCodeSandbox
          style={{ position: "relative", top: 4 }}
          size={20}
        />
      </a>
    </div>
  )
}

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  if (location.pathname === rootPath) {
    header = (
      <div className="header-wrapper">
        <h1
          style={{
            ...scale(1.5),
            marginBottom: rhythm(1.5),
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h1>
        <SocialIcons />
      </div>
    )
  } else {
    header = (
      <div className="header-post-wrapper">
        <h3
          style={{
            fontFamily: `Montserrat, sans-serif`,
            marginTop: 0,
          }}
        >
          <Link
            style={{
              boxShadow: `none`,
              color: `inherit`,
            }}
            to={`/`}
          >
            {title}
          </Link>
        </h3>
        <SocialIcons />
      </div>
    )
  }
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <header>{header}</header>
      <main>{children}</main>
    </div>
  )
}

export default Layout
